import React from 'react';

import { LegacyProjectFieldsPageMountEfaOptInMenuItem } from '@jira/admin-pages__field-schemes/src/ui/legacy-cmp-project/LegacyProjectFieldsPageMountEfaOptInMenuItem.tsx';
import { LegacyPage } from '@atlassian/jira-router-routes-common/src/ui/legacy-page/main.tsx';
import type { RouteContext } from '@atlassian/react-resource-router';

/**
 * We only intend to render the contents of this component when the route matches
 * 'legacy-project-settings-fields' and the experiment 'jira_efa_for_cmp_m2_experiment' is enabled.
 *
 * This is a temporary workaround so we can roll out the first phase of EFA for CMP.
 *
 * The second phase will be to replace the page at the 'legacy-project-settings-fields'
 * URL with a new page served by AFM SPA. Once rolled out, this code can then be removed.
 *
 * The actual code is split off to avoid increasing size of jira-spa bundle.
 */
type Props = RouteContext;

export const CmpProjectSettingsFieldsLegacyPage = (props: Props) => {
	const { route } = props;

	return (
		<>
			{/* Must render legacy page component for consistency */}
			<LegacyPage {...props} />
			{route.name === 'legacy-project-settings-fields' && (
				<LegacyProjectFieldsPageMountEfaOptInMenuItem />
			)}
		</>
	);
};
